import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'clima'
})
export class ClimaPipe implements PipeTransform {

    transform(value: number, nome: string): any {

        if (value === null || value === undefined) {
            return value;
        }

        let casasDecimais = 0;
        let sufixo = '';

        switch (nome.toLowerCase()) {
            case 'temperatura':
                casasDecimais = 1;
                sufixo = 'º C';
                break;
            case 'vento':
                sufixo = ' km/h';
                break;
            case 'chuva':
                sufixo = ' mm';
                break;
            case 'umidade':
                sufixo = '%';
                break;
            default:
                break;
        }

        return value.toFixed(casasDecimais) + sufixo;
    }

}
